import React from 'react';
import '../blocks/ModernBlocks.css';

const StoryBlock = ({ data }) => {
  return (
    <section className="story-section">
      <div className="story-container">
        <div className="story-header">
          <h2 className="story-title">{data.title}</h2>
          <p className="story-subtitle">{data.subtitle}</p>
        </div>
        <div className="story-timeline">
          {data.content.map((item, index) => (
            <div key={index} className={`story-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="story-content">
                <div className="story-year">{item.year}</div>
                <h3 className="story-item-title">{item.title}</h3>
                <p className="story-description">{item.description}</p>
              </div>
              <div className="story-image">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="story-connector"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoryBlock; 